import { SwitchField } from "melco-shared-logic";
import { useTranslation } from "react-i18next";

export const ColumnInputFormatDetailForm: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <SwitchField
        name="headers"
        label={t("inputFormats.detail.form.label.headers")}
      />
    </>
  );
};
